<template>
    <div class="resume-box">
        <div class="resume-flex-inlin">
            <div class="flex-left-info">
                <h3>{{info.companyName}}</h3>
                <div class="address-exp">
                    <i class="el-icon-location-outline size-icon"></i>
                    {{info.provinceName}} · {{info.cityName}}
                    <!-- <el-divider direction="vertical"></el-divider> -->
                    <span class="type-state">{{info.rolesName}}</span>
                </div>
            </div>
        </div>
        <template v-if="info.levelShow">
            <div class="divider"></div>
            <div class="resume-rate">
                <div class="rate-item">
                    <div class="rate-item-fen">{{info.technicalLevel}}</div>
                    <div class="rate-item-label">技术能力</div>
                </div>
                <div class="rate-item">
                    <div class="rate-item-fen">{{info.behaviorLevel}}</div>
                    <div class="rate-item-label">言行举止</div>
                </div>
                <div class="rate-item">
                    <div class="rate-item-fen">{{info.serviceQualityLevel}}</div>
                    <div class="rate-item-label">服务质量</div>
                </div>
            </div>
        </template>
        <div class="divider"></div>
        <div class="resume-content">
            <div class="resume-item">
                <h3>认证领域</h3>
                <el-card shadow="never" class="card-bg">
                    <div class="certification-field">
                        <div class="field-item">
                            <label>擅长产品：</label>
                            <div class="item-content" v-if="authAreaProdVOS.length">{{authAreaProdVOS.join('、')}}</div>
                            <div class="item-content" v-else>暂无</div>
                        </div>
                        <div class="field-item">
                            <label>擅长品牌：</label>
                            <div class="item-content" v-if="authAreaBrandVOS.length">{{authAreaBrandVOS.join('、')}}</div>
                            <div class="item-content" v-else>暂无</div>
                        </div>
                        <div class="field-item">
                            <label>原厂认证：</label>
                            <ul class="item-certification" v-if="info.authAreaVO && info.authAreaVO.authAreaFactoryVOS.length">
                                <li v-for="(item,index) in info.authAreaVO.authAreaFactoryVOS" :key="index">{{item.productName + ' — ' + item.brandName}}</li>
                            </ul>
                            <div class="item-content" v-else>暂无</div>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="resume-item">
                <h3>项目经历</h3>
                <el-card shadow="never" class="card-bg job-card" v-for="(item,index) in info.successfulCaseList" :key="index">
                    <div class="job-experience">   
                        <div class="job-items-time">
                            <h4>{{item.projectname}}</h4>
                            <div>{{item.projectyear}}年</div>
                        </div>
                        <p class="job-items-tip">{{item.industryname}}  |  {{item.servicetypename}}</p>
                        <div class="job-items-det">{{item.servicedesc}}</div>
                    </div>
                </el-card>
            </div>
            <div class="resume-item">
                <h3>资质证书</h3>
                <el-card shadow="never" class="card-bg job-card" v-for="(item,index) in info.accountCertificateList" :key="index">
                    <div class="ability-certificate">{{item.name}}</div>
                </el-card>
            </div>
            <div class="resume-item">
                <div class="flex-inlin-items">
                    <h3>工程师团队</h3>
                    <div class="engineer-number" v-if="info.egrTeamList && info.egrTeamList.length">{{info.egrTeamList.length}} 人</div>
                </div>
                <el-card shadow="never" class="card-bg job-card" v-for="(item,index) in info.egrTeamList" :key="index">
                    <div class="engineer-itmes">
                        <div class="flex-items">
                            <div class="ability-certificate">{{item.trueName}}</div>
                            <div class="flow-div">{{item.workDateCount}}年 </div>
                        </div>
                        <div class="phone">{{item.handset || '--'}}</div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        resumeInfo,            //服务站简历
    } from "@/scripts/api.js";
    export default {
        data(){
            return {
                info:{},
                authAreaProdVOS: [],    //擅长产品
                authAreaBrandVOS: [],   //擅长品牌
            }
        },
        methods: {
            async GetBasicInfo(id){
                this.authAreaProdVOS = []
                this.authAreaBrandVOS = []
                let params = {}
                params.nuserId = id
                params.nuserType = 2
                let res = await resumeInfo(params)
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.info = res.Data.stationInfoVO
                if(this.info.authAreaVO.authAreaProdVOS.length) {
                    this.info.authAreaVO.authAreaProdVOS.map(obj=>{
                        this.authAreaProdVOS.push(obj.productName)
                    })
                }
                if(this.info.authAreaVO.authAreaBrandVOS.length) {
                    this.info.authAreaVO.authAreaBrandVOS.map(obj => {
                        this.authAreaBrandVOS.push(obj.brandName)
                    })
                }
            },
        }

    }
</script>
<style lang="scss">
    .resume-box {
        .size-icon {
            line-height: 20px;
            font-size: 20px;
            color: #f75959;
            margin-right: 4px;
        }
        .resume-flex-inlin {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }
        .flex-left-info {
            color: #333333;
            flex: 1;
            h3 {
                line-height: 30px;
                font-size: 26px;
                font-weight: bold;
            }
            .address-exp {
                display: flex;
                align-items: center;
                padding: 10px 0;
                font-size: 15px;
                line-height: 20px;
                .type-state {
                    display: inline-block;
                    vertical-align: middle;
                    background: #76CC7C;
                    font-size: 12px;
                    text-align: center;
                    color: #ffffff;
                    line-height: 20px;
                    padding: 0 10px;
                    border-radius: 2px;
                    margin-left: 20px;
                }
            }
        }
        .flex-right-erweima {
            flex: 0 0 160px;
            .erweima {
                text-align: center;
            }
            .icon-erweima {
                font-size: 54px;
            }
        }
        .divider {
            width: 100%;
            height: 20px;
            background: #F1F1F1;
        }
        .resume-rate {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 20px 0;
            .rate-item {
                flex:  0 0 33.33%;
                text-align: center;
                .rate-item-fen {
                    color: #333333;
                    font-size: 28px;
                    font-weight: 500;
                }
                .rate-item-label {
                    font-size: 18px;
                    color: #999999;
                    font-weight: 400;
                    line-height: 42px;
                }
                &:first-child {
                    border-right: 2px solid #F1F1F1;
                }
                &:last-child {
                    border-left: 2px solid #F1F1F1;
                }
            }
        }
        .resume-content {
            .resume-item {
                .flex-inlin-items {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    >div.engineer-number {
                        font-size: 22px;
                        color: #333333;
                        font-weight: bold;
                        line-height: 30px;
                        margin-top: 40px;
                        margin-bottom: 10px;
                    }
                }
                h3 {
                    font-size: 22px;
                    color: #333333;
                    font-weight: bold;
                    line-height: 30px;
                    margin-top: 40px;
                    margin-bottom: 10px;
                }
                .card-bg {
                    background: #F1F1F1;
                    border-radius: 4px;
                    .el-card__body {
                        padding: 15px 20px;
                    }
                }
                .job-card {
                    margin-bottom: 20px;
                }
                .engineer-itmes {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .phone {
                        line-height: 24px;
                    }
                    .flex-items {
                        display: flex;
                        align-items: center;
                    }
                    .flow-div {
                        font-size: 12px;
                        text-align: center;
                        color: #ffffff;
                        margin-left: 20px;
                        position: relative;
                        padding-right: 16px;
                        padding-left: 8px;
                        line-height: 20px;
                        background: #f75959;
                        white-space: nowrap;
                        overflow: visible;
                        &:before,
                        &:after {
                            content: ' ';
                            display: block;
                            width: 0;
                            height: 0;
                            border-style: solid; 
                            border-width: 10px 6px 10px 0px;
                            border-color: transparent #F1F1F1 transparent transparent; 
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                        &:before {
                            border-right-color: #f75959;
                            z-index: 1;
                            left: -6px;
                        }
                        &:after {
                            left: auto; 
                            right: 0; 
                            z-index: 2
                        }
                    }
                }
            }
            .certification-field {
                .field-item {
                    position: relative;
                    padding-left: 90px;
                    margin-bottom: 15px;
                    label {
                        position: absolute;
                        left: 0;
                        top: 0;
                        color: #999999;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 36px;
                    }
                    .item-content {
                        font-size: 18px;
                        color: #333333;
                        font-weight: bold;
                        line-height: 36px;
                    }
                }
                .item-certification {
                    li {
                        background: #76CC7C;
                        margin-bottom: 10px;
                        height: 36px;
                        border-radius: 5px;
                        padding: 0 20px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 36px;
                        color: #ffffff;
                        text-align: center;
                    }

                }
            }
            .job-experience {
                .job-items-time {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    h4 {
                        flex: 1;
                        font-size: 18px;
                        font-weight: bold;
                        color: #333333;
                        padding-right: 10px;
                    }
                    div {
                        font-size: 14px;
                        color: #999999;
                    }
                }
                .job-items-tip {
                    color: #999999;
                    font-size: 14px;
                    margin: 10px 0;
                }
                .job-items-det {
                    font-size: 16px;
                    line-height: 24px;
                    color: #333333;
                    font-weight: 400;
                }
            }
            .ability-certificate,
            .phone {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }
        }
    }
</style>